import createModelStore from "../../utils/createModelStore";
import Permission from "../../services/Permission";

const permissions = createModelStore<Permission.Model, "permissions">(
	"permissions",
);

export default permissions;
